export const OrderScheduleBlacklistItem = (json: IOrderScheduleLimitation): IOrderScheduleLimitationModel => {
	const { blacklist_date, is_recurring, ...rest } = json

	return {
		...rest,
		blacklistDate: new Date(blacklist_date),
		isRecurring: is_recurring,
	}
}

export const OrderScheduleBlacklistList = (json: IOrderScheduleLimitationList): IOrderScheduleLimitationListModel => {
	const { recurring, non_recurring } = json

	return {
		recurring: recurring.map(item => OrderScheduleBlacklistItem(item)),
		nonRecurring: non_recurring.map(item => OrderScheduleBlacklistItem(item)),
	}
}

export const OrderScheduleLimitationToJson = (
	model: IOrderScheduleLimitationCreate,
): IOrderScheduleLimitationCreateJson => {
	const { blacklistDate, isRecurring, ...rest } = model

	return {
		...rest,
		blacklist_date: dateToFilterFormat(blacklistDate),
		is_recurring: isRecurring,
	}
}

export const OrderScheduleOperation = (json: IOrderScheduleOperation): IOrderScheduleOperationModel => {
	const { delivery_weekday, deadline_weekday, deadline_time, operation_type, created_at, updated_at, ...rest } = json

	return {
		...rest,
		deliveryWeekday: delivery_weekday,
		deadlineWeekday: deadline_weekday,
		deadlineTime: deadline_time,
		operationType: operation_type,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const OrderScheduleOperationPayloadToBody = (payload: IOrderScheduleDeadlineModel): IOrderScheduleDeadline =>
	(Object.keys(payload) as EOrderScheduleTypes[]).reduce((acc, key) => {
		const item = payload[key]
		acc[key] = {
			deadline_weekday: item.deadlineWeekday,
			deadline_time: `${item.deadlineTime}:00`,
		}
		return acc
	}, {} as IOrderScheduleDeadline)
